// ag-grid-enterprise v21.2.2
"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axis_1 = require("../../axis");

var linearScale_1 = require("../../scale/linearScale");

var NumberAxis =
/** @class */
function (_super) {
  __extends(NumberAxis, _super);

  function NumberAxis() {
    var _this = _super.call(this, linearScale_1.default()) || this;

    _this._nice = true;
    _this.scale.clamp = true;
    return _this;
  }

  Object.defineProperty(NumberAxis.prototype, "nice", {
    get: function get() {
      return this._nice;
    },
    set: function set(value) {
      if (this._nice !== value) {
        this._nice = value;

        if (value && this.scale.nice) {
          this.scale.nice(10);
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NumberAxis.prototype, "domain", {
    get: function get() {
      return this.scale.domain;
    },
    set: function set(value) {
      this.scale.domain = value;

      if (this.nice && this.scale.nice) {
        this.scale.nice(10);
      }
    },
    enumerable: true,
    configurable: true
  });
  return NumberAxis;
}(axis_1.Axis);

exports.NumberAxis = NumberAxis;